// src/redux-saga/actions/knowledgeBaseActions.js

// Existing Action Types
export const FETCH_KB_REQUEST = 'FETCH_KB_REQUEST';
export const FETCH_KB_SUCCESS = 'FETCH_KB_SUCCESS';
export const FETCH_KB_FAILURE = 'FETCH_KB_FAILURE';

export const CREATE_KB_REQUEST = 'CREATE_KB_REQUEST';
export const CREATE_KB_SUCCESS = 'CREATE_KB_SUCCESS';
export const CREATE_KB_FAILURE = 'CREATE_KB_FAILURE';

export const DELETE_KB_REQUEST = 'DELETE_KB_REQUEST';
export const DELETE_KB_SUCCESS = 'DELETE_KB_SUCCESS';
export const DELETE_KB_FAILURE = 'DELETE_KB_FAILURE';

export const UPDATE_KB_REQUEST = 'UPDATE_KB_REQUEST';
export const UPDATE_KB_SUCCESS = 'UPDATE_KB_SUCCESS';
export const UPDATE_KB_FAILURE = 'UPDATE_KB_FAILURE';

// File-related Action Types
export const FETCH_KB_FILES_REQUEST = 'FETCH_KB_FILES_REQUEST';
export const FETCH_KB_FILES_SUCCESS = 'FETCH_KB_FILES_SUCCESS';
export const FETCH_KB_FILES_FAILURE = 'FETCH_KB_FILES_FAILURE';

export const FETCH_KB_FILE_CONTENT_REQUEST = 'FETCH_KB_FILE_CONTENT_REQUEST';
export const FETCH_KB_FILE_CONTENT_SUCCESS = 'FETCH_KB_FILE_CONTENT_SUCCESS';
export const FETCH_KB_FILE_CONTENT_FAILURE = 'FETCH_KB_FILE_CONTENT_FAILURE';

export const UPLOAD_FILES_REQUEST = 'UPLOAD_FILES_REQUEST';
export const UPLOAD_FILES_SUCCESS = 'UPLOAD_FILES_SUCCESS';
export const UPLOAD_FILES_FAILURE = 'UPLOAD_FILES_FAILURE';

export const DELETE_KB_FILE_REQUEST = 'DELETE_KB_FILE_REQUEST';
export const DELETE_KB_FILE_SUCCESS = 'DELETE_KB_FILE_SUCCESS';
export const DELETE_KB_FILE_FAILURE = 'DELETE_KB_FILE_FAILURE';

// Site-related Action Types
export const FETCH_KB_SITES_REQUEST = 'FETCH_KB_SITES_REQUEST';
export const FETCH_KB_SITES_SUCCESS = 'FETCH_KB_SITES_SUCCESS';
export const FETCH_KB_SITES_FAILURE = 'FETCH_KB_SITES_FAILURE';

export const FETCH_SITE_CONTENT_REQUEST = 'FETCH_SITE_CONTENT_REQUEST';
export const FETCH_SITE_CONTENT_SUCCESS = 'FETCH_SITE_CONTENT_SUCCESS';
export const FETCH_SITE_CONTENT_FAILURE = 'FETCH_SITE_CONTENT_FAILURE';

export const ADD_KB_SITE_REQUEST = 'ADD_KB_SITE_REQUEST';
export const ADD_KB_SITE_SUCCESS = 'ADD_KB_SITE_SUCCESS';
export const ADD_KB_SITE_FAILURE = 'ADD_KB_SITE_FAILURE';

export const DELETE_KB_SITE_REQUEST = 'DELETE_KB_SITE_REQUEST';
export const DELETE_KB_SITE_SUCCESS = 'DELETE_KB_SITE_SUCCESS';
export const DELETE_KB_SITE_FAILURE = 'DELETE_KB_SITE_FAILURE';

// Clear file content action type
export const CLEAR_FILE_CONTENT = 'CLEAR_FILE_CONTENT';

// Action Creators
export const fetchKbRequest = () => ({ type: FETCH_KB_REQUEST });
export const fetchKbSuccess = (data) => ({ type: FETCH_KB_SUCCESS, payload: data });
export const fetchKbFailure = (error) => ({ type: FETCH_KB_FAILURE, payload: error });

export const createKbRequest = (kbData) => ({ type: CREATE_KB_REQUEST, payload: kbData });
export const createKbSuccess = (data) => ({ type: CREATE_KB_SUCCESS, payload: data });
export const createKbFailure = (error) => ({ type: CREATE_KB_FAILURE, payload: error });

export const deleteKbRequest = (kbId) => ({ type: DELETE_KB_REQUEST, payload: kbId });
export const deleteKbSuccess = (kbId) => ({ type: DELETE_KB_SUCCESS, payload: kbId });
export const deleteKbFailure = (error) => ({ type: DELETE_KB_FAILURE, payload: error });

export const DOWNLOAD_FILE_REQUEST = 'DOWNLOAD_FILE_REQUEST';
export const DOWNLOAD_FILE_SUCCESS = 'DOWNLOAD_FILE_SUCCESS';
export const DOWNLOAD_FILE_FAILURE = 'DOWNLOAD_FILE_FAILURE';

export const updateKbRequest = (id, data) => ({ type: UPDATE_KB_REQUEST, payload: { id, data } });
export const updateKbSuccess = (updatedData) => ({ type: UPDATE_KB_SUCCESS, payload: updatedData });
export const updateKbFailure = (error) => ({ type: UPDATE_KB_FAILURE, payload: error });

// File-related Action Creators
export const fetchKbFilesRequest = (kbId) => ({ type: FETCH_KB_FILES_REQUEST, payload: kbId });
export const fetchKbFilesSuccess = (kbId, files) => ({
  type: FETCH_KB_FILES_SUCCESS,
  payload: { kbId, files },
});
export const fetchKbFilesFailure = (error) => ({ type: FETCH_KB_FILES_FAILURE, payload: error });

export const fetchKbFileContentRequest = (fileId) => ({
  type: FETCH_KB_FILE_CONTENT_REQUEST,
  payload: fileId,
});
export const fetchKbFileContentSuccess = (content) => ({
  type: FETCH_KB_FILE_CONTENT_SUCCESS,
  payload: content,
});
export const fetchKbFileContentFailure = (error) => ({
  type: FETCH_KB_FILE_CONTENT_FAILURE,
  payload: error,
});

export const uploadFilesRequest = (formData) => ({ type: UPLOAD_FILES_REQUEST, payload: formData });
export const uploadFilesSuccess = (kbId, files) => ({
  type: UPLOAD_FILES_SUCCESS,
  payload: { kbId, files },
});
export const uploadFilesFailure = (error) => ({ type: UPLOAD_FILES_FAILURE, payload: error });

export const deleteKbFileRequest = (fileId, kbId) => ({
  type: DELETE_KB_FILE_REQUEST,
  payload: { fileId, kbId },
});
export const deleteKbFileSuccess = (kbId, fileId) => ({
  type: DELETE_KB_FILE_SUCCESS,
  payload: { kbId, fileId },
});
export const deleteKbFileFailure = (error) => ({ type: DELETE_KB_FILE_FAILURE, payload: error });

export const downloadFileRequest = (fileId) => ({
  type: DOWNLOAD_FILE_REQUEST,
  payload: fileId,
});

export const downloadFileSuccess = (fileData) => ({
  type: DOWNLOAD_FILE_SUCCESS,
  payload: fileData,
});

export const downloadFileFailure = (error) => ({
  type: DOWNLOAD_FILE_FAILURE,
  payload: error,
});

// Site-related Action Creators
export const fetchKbSitesRequest = (kbId) => ({ type: FETCH_KB_SITES_REQUEST, payload: kbId });
export const fetchKbSitesSuccess = (kbId, sites) => ({
  type: FETCH_KB_SITES_SUCCESS,
  payload: { kbId, sites },
});
export const fetchKbSitesFailure = (error) => ({ type: FETCH_KB_SITES_FAILURE, payload: error });

export const fetchSiteContentRequest = (siteId) => ({
  type: FETCH_SITE_CONTENT_REQUEST,
  payload: siteId,
});
export const fetchSiteContentSuccess = (content) => ({
  type: FETCH_SITE_CONTENT_SUCCESS,
  payload: content,
});
export const fetchSiteContentFailure = (error) => ({
  type: FETCH_SITE_CONTENT_FAILURE,
  payload: error,
});

export const addKbSiteRequest = (siteData) => ({ type: ADD_KB_SITE_REQUEST, payload: siteData });
export const addKbSiteSuccess = (kbId, site) => ({
  type: ADD_KB_SITE_SUCCESS,
  payload: { kbId, site },
});
export const addKbSiteFailure = (error) => ({ type: ADD_KB_SITE_FAILURE, payload: error });

export const deleteKbSiteRequest = (siteId, kbId) => ({
  type: DELETE_KB_SITE_REQUEST,
  payload: { siteId, kbId },
});
export const deleteKbSiteSuccess = (kbId, siteId) => ({
  type: DELETE_KB_SITE_SUCCESS,
  payload: { kbId, siteId },
});
export const deleteKbSiteFailure = (error) => ({ type: DELETE_KB_SITE_FAILURE, payload: error });

// Clear file content action creator
export const clearFileContent = () => ({ type: CLEAR_FILE_CONTENT });
